import { render, staticRenderFns } from "./SocialMediaHint.vue?vue&type=template&id=1f03190f&scoped=true&"
import script from "./SocialMediaHint.vue?vue&type=script&lang=js&"
export * from "./SocialMediaHint.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaHint.vue?vue&type=style&index=0&id=1f03190f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f03190f",
  null
  
)

export default component.exports